import api from './api';

export const userService = {
  // Dashboards según rol
  adminDashboard: async () => {
    const response = await api.get('/admin/dashboard');
    return response.data;
  },

  establishmentDashboard: async () => {
    const response = await api.get('/establishment/dashboard');
    return response.data;
  },

  clientDashboard: async () => {
    const response = await api.get('/client/dashboard');
    return response.data;
  },

  // Gestión de usuarios (solo admin)
  getAllUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },

  getUsersByRole: async (role) => {
    const response = await api.get(`/admin/users/role/${role}`);
    return response.data;
  },

  changeUserRole: async (userId, role) => {
    const response = await api.put(`/admin/users/${userId}/role`, { role });
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post('/admin/users', userData);
    return response.data;
  },

  // Verificar rol del usuario actual
  hasRole: (requiredRole) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.role === requiredRole;
  },

  isAdmin: () => {
    return userService.hasRole('administrador');
  },

  isEstablishment: () => {
    return userService.hasRole('establecimiento');
  },

  isClient: () => {
    return userService.hasRole('cliente');
  },

  updatePerfil: async (data) => {
    const response = await api.put('/establishment/perfil', data);
    return response.data;
  }
};
